export default "__VITE_ASSET__FFgWQSCw__"